import React from 'react';
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';

export const W9FileNameDisplay: React.FC = () => {
    const w9FileName = useBrokerDetailsStore((s) => s.w9FileName);

    return (
        <>
            <h2 className='decorated'>W9 File</h2>
            <label htmlFor='w9File'>Uploaded W9 File:</label>
            <p>{w9FileName}</p>
        </>
    );
};
